import { Link } from "react-router-dom";
import { SiteShell } from "@/components/site/SiteShell";
import { SEO } from "@/components/site/SEO";
import { Button } from "@/components/ui/button";
import { ArrowRight, Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <SiteShell>
      <SEO title="Page not found" description="This page does not exist or has moved." noindex />
      <section className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="text-center">
          <div className="font-display text-[hsl(var(--primary))] text-[clamp(6rem,18vw,14rem)] leading-none">404</div>
          <h1 className="font-display uppercase text-foreground text-3xl sm:text-4xl tracking-[0.02em]">Lost in post.</h1>
          <p className="mt-4 text-sm sm:text-base text-muted-foreground max-w-md mx-auto">That page doesn’t exist or has moved. Head home, or browse our recent work and articles.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button asChild className="h-11 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:brightness-110 px-5"><Link to="/"><HomeIcon className="mr-2 h-4 w-4" /> Home</Link></Button>
            <Button asChild variant="ghost" className="h-11 rounded-full border border-border bg-card/60 px-5"><Link to="/portfolio">Our work</Link></Button>
            <Button asChild variant="ghost" className="h-11 rounded-full border border-border bg-card/60 px-5"><Link to="/blog">Blog</Link></Button>
            <Button asChild variant="ghost" className="h-11 rounded-full border border-border bg-card/60 px-5"><Link to="/contact">Contact <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
